var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 25.6654C12.7112 25.6654 11.6665 24.6207 11.6665 23.332H16.3332C16.3332 24.6207 15.2885 25.6654 13.9998 25.6654ZM23.3332 22.1654H4.6665V19.832L6.99984 18.6654V12.2487C6.99984 8.2097 8.65767 5.59053 11.6665 4.87536V2.33203H15.1665C14.4058 3.33996 13.996 4.56925 13.9998 5.83203C13.9998 6.12531 14.0216 6.41817 14.0652 6.7082H13.9998C12.5763 6.616 11.2033 7.25263 10.354 8.3987C9.62781 9.54735 9.2715 10.8911 9.33317 12.2487V19.832H18.6665V12.2487C18.6665 12.0025 18.6583 11.7657 18.642 11.5487C19.4137 11.7081 20.2095 11.7109 20.9823 11.5569C20.9952 11.803 20.9998 12.0375 20.9998 12.2569V18.6654L23.3332 19.832V22.1654ZM19.8332 9.33203C19.1283 9.33288 18.4396 9.12015 17.858 8.72187C16.4834 7.78221 15.9611 6.00424 16.6091 4.47042C17.257 2.9366 18.8959 2.07161 20.5278 2.40207C22.1598 2.73254 23.333 4.16696 23.3332 5.83203C23.3332 7.76503 21.7662 9.33203 19.8332 9.33203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.efaf164fe83bae9808c4868e7f08f060.svg";
export { ForwardRef as ReactComponent };